import { create } from "zustand";

const useOrgRatingStore = create((set) => ({
  orgRating: [],
  setOrgRating: (newData) => set({ orgRating: newData }),
  isLoading: true,
  setLoading: (loading) => set({ isLoading: loading })
}));

export default useOrgRatingStore; 